/** @file findEntry: one facet entry of an impostor by drawable id and entry index. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { ImpostorDrawable } from '@zilo/pose3d-format/types/drawable';
import type { FacetEntry } from '@zilo/pose3d-format/types/facet';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import { findDrawable } from '../drawable/findDrawable';

/** The impostor, its index and entry `entry`; `NOT_FOUND` (drawable, index) or `VALIDATION` (not an impostor). */
export function findEntry(puppet: Pick<Puppet, 'drawables'>, drawable: string, entry: number): { drawableIndex: number; impostor: ImpostorDrawable; entry: FacetEntry } {
  const { index, drawable: d } = findDrawable(puppet, drawable);
  if (d.kind !== 'impostor') throwError(ERROR_CODES.VALIDATION, { drawable, kind: d.kind }, { path: '/input/drawable', hint: 'facet entries belong to impostors' });
  const e = d.facets[entry];
  if (e === undefined) throwError(ERROR_CODES.NOT_FOUND, { drawable, entry }, { path: '/input/entry', hint: `entries 0..${d.facets.length - 1}` });
  return { drawableIndex: index, impostor: d, entry: e };
}
